/* eslint-disable max-len */
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import LocationIcon from '@mui/icons-material/LocationCity';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import AddIcon from '@mui/icons-material/AddBoxOutlined';
import AddBusinessIcon from '@mui/icons-material/AddBusiness';
import AddchartIcon from '@mui/icons-material/Addchart';
import RouteIcon from '@mui/icons-material/AltRouteOutlined';
import AppsIcon from '@mui/icons-material/Apps';
import PickupIcon from '@mui/icons-material/ArrowForward';
import BuildIcon from '@mui/icons-material/Build';
import DutiesCostCalculator from '@mui/icons-material/CalculateOutlined';
import { FaBarcode } from '@react-icons/all-files/fa/FaBarcode';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import DashboardIcon from '@mui/icons-material/DashboardOutlined';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import ImportIcon from '@mui/icons-material/ImportExport';
import LabelIcon from '@mui/icons-material/Label';
import LanguageIcon from '@mui/icons-material/Language';
import WeightIcon from '@mui/icons-material/LineWeight';
import ListIcon from '@mui/icons-material/ListAltOutlined';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import LogingLogsIcon from '@mui/icons-material/LoginOutlined';
import MoneyIcon from '@mui/icons-material/MonetizationOn';
import PricingIcon from '@mui/icons-material/Money';
import PlusOneIcon from '@mui/icons-material/PlusOne';
import GlobeIcon from '@mui/icons-material/Public';
import SecurityIcon from '@mui/icons-material/Security';
// import PdfIcon from '@mui/icons-material/PictureAsPdf';
import SettingsIcon from '@mui/icons-material/Settings';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import StoreIcon from '@mui/icons-material/Store';
import UsersIcon from '@mui/icons-material/SupervisedUserCircle';
import TrackingIcon from '@mui/icons-material/TrackChanges';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import VerifiedUser from '@mui/icons-material/VerifiedUser';
import ParcelsIcon from '@mui/icons-material/Work';
import KeyIcon from '@mui/icons-material/Key';
// import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import MultiRouteIcon from '@mui/icons-material/AccountTreeRounded';
import { IoIosQrScanner } from '@react-icons/all-files/io/IoIosQrScanner';
import { IoIosAirplane } from '@react-icons/all-files/io/IoIosAirplane';
import { IoIosBarcode } from '@react-icons/all-files/io/IoIosBarcode';
import { IoIosBriefcase } from '@react-icons/all-files/io/IoIosBriefcase';
import { IoMdAirplane } from '@react-icons/all-files/io/IoMdAirplane';

import QuickbooksIcon from 'components/Icons/Quickbooks';
import TrackingCodeIcon from '@mui/icons-material/Code';
import { MuiPage } from './pages';

const pagesES: readonly MuiPage[] = [
  {
    label: 'Panel de control',
    icon: DashboardIcon,
    pathname: '/admin/dashboard',
    roles: [
      'admin',
      'customer',
      'wholesaler',
      'retailer',
      'reseller',
      'reseller_customer',
      'wholesaler_customer',
      'dev',
      'accounting',
      'accounting_chief',
      'warehouse',
      'analyst',
      'shipping_marketplace',
    ],
  },
  {
    label: 'Cuentas',
    icon: UsersIcon,
    roles: [
      'admin',
      'accounting',
      'accounting_chief',
      'warehouse',
      'reseller',
      'retailer',
      'wholesaler',
    ],
    children: [
      {
        label: 'Usuarios',
        icon: AccountCircleIcon,
        pathname: '/admin/users',
        roles: ['admin', 'accounting', 'accounting_chief'],
      },
      {
        label: 'Cuentas',
        icon: AccountTreeIcon,
        pathname: '/admin/accounts',
        roles: ['admin', 'accounting', 'accounting_chief'],
      },
      // {
      //   label: 'Accounts pending',
      //   icon: ManageAccountsIcon,
      //   pathname: '/admin/accounts/pending_review',
      //   roles: ['admin', 'accounting', 'accounting_chief'],
      // },
      {
        label: 'Marca blanca',
        icon: LabelIcon,
        roles: ['admin', 'warehouse', 'reseller', 'retailer', 'wholesaler'],
        pathname: '/admin/white-labels',
      },
      {
        label: 'Autorizaciones de códigos HS',
        icon: () => <AppsIcon />,
        pathname: '/admin/harmonized-codes-restrictions-auth',
        roles: ['admin', 'warehouse'],
      },
      {
        label: 'Buenas categorías',
        icon: () => <AppsIcon />,
        pathname: '/admin/good-categories',
        roles: ['admin', 'warehouse'],
      },
      {
        label: 'Categorías del Código HS',
        icon: () => <AppsIcon />,
        pathname: '/admin/hs-code-categories',
        roles: ['admin', 'warehouse', 'reseller', 'retailer', 'wholesaler', 'reseller_customer'],
      },
      {
        label: 'Categorización de códigos HS',
        icon: () => <AppsIcon />,
        pathname: '/admin/account-hs-code-categorization',
        roles: ['admin', 'warehouse'],
      },
      {
        label: 'Intercambio de códigos HS',
        icon: () => <AppsIcon />,
        pathname: '/admin/harmonized-codes-interchange',
        roles: ['admin', 'warehouse'],
      },
    ],
  },
  {
    label: 'Paquetes',
    icon: ParcelsIcon,
    roles: [
      'admin',
      'warehouse',
      'analyst',
      'reseller',
      'retailer',
      'wholesaler',
      'reseller_customer',
      'read_only',
    ],
    badge: true,
    badgeCallback: 'loadParcelsPendingReview',
    badgeVar: 'countParcelsPendingReview',
    children: [
      {
        label: 'Añadir nuevo',
        icon: AddIcon,
        pathname: '/admin/edit-parcel',
        roles: [
          'admin',
          'customer',
          'wholesaler',
          'retailer',
          'reseller',
          'reseller_customer',
          'wholesaler_customer',
          'dev',
          'accounting',
          'accounting_chief',
          'warehouse',
          'analyst',
          'shipping_marketplace',
        ],
      },
      {
        label: 'Todos los pedidos',
        icon: ListIcon,
        pathname: '/admin/parcels',
      },
      {
        label: 'A la espera de envío',
        icon: ListIcon,
        pathname: '/admin/awaiting-shipping',
        roles: ['admin', 'warehouse'],
      },
      {
        label: 'Importaciones',
        icon: ImportIcon,
        pathname: '/admin/parcel-imports',
        roles: [
          'admin',
          'customer',
          'wholesaler',
          'retailer',
          'reseller',
          'reseller_customer',
          'wholesaler_customer',
          'dev',
          'accounting',
          'accounting_chief',
          'warehouse',
          'analyst',
          'shipping_marketplace',
        ],
      },
      {
        label: 'Importar encomendas 3PL',
        icon: ImportIcon,
        pathname: '/admin/parcel-imports-dl-packet',
        roles: ['admin', 'import_3pl_parcels'],
      },
      {
        label: 'Zona de escaneo',
        icon: IoIosQrScanner,
        pathname: '/admin/parcel-scan',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Prueba de Scan Zone',
        icon: IoIosQrScanner,
        pathname: '/admin/parcel-scanv2',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Escaneo de origen',
        icon: IoIosQrScanner,
        pathname: '/admin/origin-scan',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Seguimiento de eventos',
        icon: TrackingIcon,
        pathname: '/admin/tracking-events',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Calculadora de impuestos y aranceles',
        icon: DutiesCostCalculator,
        pathname: '/admin/duties-cost-calculator',
        roles: ['admin', 'warehouse', 'reseller', 'retailer', 'wholesaler'],
      },
      {
        label: 'Ajuste de peso',
        icon: BuildIcon,
        pathname: '/admin/parcel-tools',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Paquetes sujetos a impuestos pendientes',
        icon: ListIcon,
        pathname: '/admin/parcels/taxed-pending',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Paquetes gravados pagados',
        icon: ListIcon,
        pathname: '/admin/parcels/taxed-paid',
        roles: ['admin', 'wholesaler', 'warehouse'],
      },
      {
        label: 'Conciliación centralizada de Amazon Payee',
        icon: ListIcon,
        pathname: '/admin/parcels-invoice-xml',
        roles: ['admin'],
      },
    ],
  },
  {
    label: 'Recogidas',
    icon: PickupIcon,
    roles: ['admin', 'warehouse', 'reseller', 'retailer', 'wholesaler'],
    children: [
      {
        label: 'Solicitar recogida',
        icon: AddIcon,
        pathname: '/admin/new-pickup',
      },
      {
        label: 'Pendiente',
        icon: ListIcon,
        pathname: '/admin/pickups/created',
      },
      {
        label: 'Completado',
        icon: ListIcon,
        pathname: '/admin/pickups/processed',
      },
      {
        label: 'Escanear',
        icon: ListIcon,
        pathname: '/admin/pickups/scan-pickup',
      },
    ],
  },
  {
    label: 'Recipientes',
    icon: (fontSize) => <FaBarcode style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
    roles: ['admin', 'warehouse', 'analyst', 'wholesaler'],
    children: [
      {
        label: 'Panel de control',
        icon: DashboardIcon,
        pathname: '/admin/receptacle-dashboard',
      },
      {
        label: 'Lista',
        icon: ListIcon,
        pathname: '/admin/receptacle-list',
      },
    ],
  },
  {
    label: 'Tipos de receptáculos',
    icon: (fontSize) => <FaBarcode style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
    roles: ['admin'],
    children: [
      {
        label: 'Lista',
        icon: ListIcon,
        pathname: '/admin/receptacle-type-list',
      },
    ],
  },
  {
    label: 'Despachos',
    icon: (fontSize) => <IoIosBarcode style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
    roles: ['admin', 'warehouse', 'analyst', 'wholesaler'],
    children: [
      {
        label: 'Carga',
        icon: ListIcon,
        pathname: '/admin/load-dispatch',
      },
      {
        label: 'Lista',
        icon: ListIcon,
        pathname: '/admin/dispatch-list',
      },
      {
        label: 'Pendiente',
        icon: ListIcon,
        pathname: '/admin/dispatches-pending',
      },
      {
        label: 'Procesado',
        icon: ListIcon,
        pathname: '/admin/dispatch-shipped',
      },
      {
        label: 'Facturas aéreas',
        icon: ListIcon,
        pathname: '/admin/airway-bills',
      },
    ],
  },
  {
    label: 'No entregable',
    icon: LocalShippingIcon,
    roles: ['admin', 'warehouse', 'analyst', 'reseller', 'retailer'],
    // pathname: '/admin/parcels-undeliverable',
    badge: true,
    badgeCallback: 'loadUndeliverable',
    badgeVar: 'countUndeliverable',
    children: [
      // {
      //   label: 'Procesado',
      //   icon: ListIcon,
      //   pathname: '/admin/parcels-undeliverable/processed',
      // },
      // {
      //   label: 'Acción requerida',
      //   icon: ListIcon,
      //   pathname: '/admin/parcels-undeliverable/action-required',
      // },
      {
        label: 'Todos los Pedidos',
        icon: ListIcon,
        pathname: '/admin/parcels-undeliverable',
      },
    ],
  },
  // {
  //   label: 'Invoices',
  //   pathname: '/admin/invoices',
  //   icon: PdfIcon,
  // },
  {
    label: 'Informes',
    icon: AccountBalanceIcon,
    roles: ['admin', 'accounting', 'accounting_chief'],
    children: [
      {
        label: 'Informe de facturación contable',
        icon: ListIcon,
        pathname: '/admin/reports',
      },
      {
        label: 'Colombia 4-72 Manifiesto',
        icon: ListIcon,
        pathname: '/admin/reports-colombia-manifest',
      },
      // {
      //   label: 'Import Unitizers Dispatches Report',
      //   icon: ListIcon,
      //   pathname: '/admin/unitizers-dispatches-report',
      // },
      {
        label: 'Informe de envíos de importación',
        icon: ListIcon,
        pathname: '/admin/dispatches-report',
      },
      {
        label: 'Reclamaciones',
        icon: ListIcon,
        pathname: '/admin/claims',
      },
      {
        label: 'BPX KPI',
        icon: ListIcon,
        pathname: '/admin/bpx-kpi',
      },
      {
        label: 'Alertas aduaneras',
        icon: ListIcon,
        pathname: '/admin/customs-alerts',
      },
    ],
  },
  {
    label: 'Configuración',
    icon: SettingsIcon,
    roles: ['admin'],
    children: [
      {
        label: 'Zonas',
        icon: LanguageIcon,
        children: [
          {
            label: 'Países',
            icon: GlobeIcon,
            pathname: '/admin/rates-countries',
          },
          {
            label: 'Estados',
            icon: ListIcon,
            pathname: '/admin/rates-states',
          },
          {
            label: 'Códigos postales',
            icon: ListIcon,
            pathname: '/admin/rates-postalcodes',
          },
        ],
      },
      {
        label: 'Depósitos por servicios',
        icon: (fontSize) => <PricingIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        pathname: '/admin/service-deposits',
      },
      {
        label: 'Precios',
        icon: (fontSize) => <MoneyIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        children: [
          {
            label: 'Precios de catálogo',
            icon: (fontSize) => <MoneyIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/list-pricing',
          },
          {
            label: 'Componer precios',
            icon: (fontSize) => <MoneyIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/compose-pricing',
          },
          {
            label: 'Redactar costes',
            icon: (fontSize) => <MoneyIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/compose-costs',
          },
          {
            label: 'Pesos',
            icon: FitnessCenterIcon,
            pathname: '/admin/weights',
          },
          {
            label: 'Rangos de dinero',
            icon: MoneyIcon,
            pathname: '/admin/money-ranges',
          },
          {
            label: 'Tarifas',
            icon: AddchartIcon,
            pathname: '/admin/tariffs',
          },
          {
            label: 'Marcado',
            icon: TrendingUpIcon,
            pathname: '/admin/markup',
          },
          {
            label: 'Tarifas del área de servicio',
            icon: CompareArrowsIcon,
            pathname: '/admin/services-areas-tariffs',
          },
          {
            label: 'Costes',
            icon: WeightIcon,
            pathname: '/admin/services-areas-weights-costs',
          },
          {
            label: 'Costos del seguro',
            icon: VerifiedUser,
            pathname: '/admin/services-areas-insurance-costs',
          },
          {
            label: 'Recargos',
            icon: PlusOneIcon,
            pathname: '/admin/services-areas-surcharges-costs',
          },
        ],
      },
      {
        label: 'Servicios',
        icon: ListIcon,
        children: [
          {
            label: 'Recogidas de servicio',
            icon: (fontSize) => <AppsIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/service-service-pickup',
          },
          {
            label: 'Servicios internos',
            icon: (fontSize) => <AppsIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/internal-services',
          },
          {
            label: 'Enrutamiento de servicios internos',
            icon: (fontSize) => <AppsIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/internal-services-services',
          },
          {
            label: 'Servicios',
            icon: (fontSize) => <AppsIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/services',
          },
          {
            label: 'Países en los que prestamos servicio',
            icon: (fontSize) => <GlobeIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/service-countries',
          },
          {
            label: 'Opciones de servicio',
            icon: (fontSize) => <AppsIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/service-options',
          },
          {
            label: 'Rutas de servicio',
            icon: (fontSize) => <RouteIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
            pathname: '/admin/service-routes',
          },
          {
            label: 'Tramos de la ruta de servicio',
            icon: (fontSize) => (
              <MultiRouteIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />
            ),
            pathname: '/admin/service-route-legs',
          },
          {
            label: 'Restricciones de los códigos armonizados',
            icon: () => <AppsIcon />,
            pathname: '/admin/harmonized-codes-restrictions',
          },
        ],
      },
      {
        label: 'Códigos armonizados',
        icon: () => <AppsIcon />,
        pathname: '/admin/harmonized-codes',
      },
      {
        label: 'Servicios externos',
        icon: ListIcon,
        children: [
          {
            label: 'Proveedores de servicios',
            icon: ListIcon,
            pathname: '/admin/rates-service-providers',
          },
          {
            label: 'Servicios',
            icon: ListIcon,
            pathname: '/admin/rates-services',
          },
          {
            label: 'Áreas de servicio Tarifas',
            icon: ListIcon,
            pathname: '/admin/rates-services-areas-tariffs',
          },
          {
            label: 'Áreas de servicios',
            icon: ListIcon,
            pathname: '/admin/rates-services-areas',
          },
          {
            label: 'Normas de servicios',
            icon: ListIcon,
            pathname: '/admin/rates-services-rules',
          },
          {
            label: 'Tipos de reglas de servicios',
            icon: ListIcon,
            pathname: '/admin/rates-services-rules-types',
          },
          {
            label: 'Proveedores de servicios Destinos',
            icon: ListIcon,
            pathname: '/admin/rates-services-providers-destinations',
          },
          {
            label: 'Países proveedores de servicios',
            icon: ListIcon,
            pathname: '/admin/rates-services-providers-countries',
          },
        ],
      },
      {
        label: 'Aeropuertos',
        icon: (fontSize) => <IoIosAirplane style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        pathname: '/admin/airports',
      },
      {
        label: 'Rutas aeroportuarias',
        icon: (fontSize) => <IoIosAirplane style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        pathname: '/admin/airport-routes',
      },
      {
        label: 'Oficinas de aeropuertos',
        icon: (fontSize) => <IoIosBriefcase style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        pathname: '/admin/airports-offices',
      },
      {
        label: 'Compañías aéreas',
        icon: (fontSize) => <IoMdAirplane style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        pathname: '/admin/airlines',
      },
      {
        label: 'Seguimiento',
        icon: TrackingIcon,
        children: [
          {
            label: 'Códigos de seguimiento',
            icon: TrackingCodeIcon,
            pathname: '/admin/tracking-codes',
          },
          {
            label: 'Códigos de seguimiento Clientes',
            icon: TrackingCodeIcon,
            pathname: '/admin/tracking-codes-customers',
          },
          {
            label: 'Proveedores de códigos de seguimiento',
            icon: TrackingCodeIcon,
            pathname: '/admin/tracking-codes-vendors',
          },
          {
            label: 'Ubicaciones limpias',
            icon: TrackingCodeIcon,
            pathname: '/admin/cleaned-locations',
          },
        ],
      },
      {
        label: 'Restricciones de la cuenta',
        icon: AccountTreeIcon,
        pathname: '/admin/account-service-restrictions',
      },
      {
        label: 'Cuenta Límite de paquetes Precio',
        icon: AccountTreeIcon,
        pathname: '/admin/account-service-price-limits',
      },
      {
        label: 'Direcciones',
        icon: LocationIcon,
        children: [
          {
            label: 'Direcciones',
            icon: LocationIcon,
            pathname: '/admin/addresses',
          },
          {
            label: 'Detalles de la dirección',
            icon: LocationIcon,
            pathname: '/admin/address-details',
          },
        ],
      },
      {
        label: 'Estaciones de entrega',
        icon: AccountTreeIcon,
        pathname: '/admin/dropoff-stations',
      },
      {
        label: 'Instalaciones',
        icon: AccountTreeIcon,
        children: [
          {
            label: 'Lista de instalaciones',
            icon: TrackingCodeIcon,
            pathname: '/admin/facilities',
          },
          {
            label: 'Normas de las instalaciones',
            icon: TrackingCodeIcon,
            pathname: '/admin/facilities-inbound-rules',
          },
        ],
      },
      {
        label: 'Quickbooks',
        icon: (fontSize) => <QuickbooksIcon style={{ fill: '#fff', fontSize: fontSize || 14 }} />,
        pathname: '/admin/quickbooks',
      },
      // {
      //   label: 'Inbound Countries',
      //   icon: (fontSize) => <IoIosGlobe style={{ fill: '#fff' , fontSize: fontSize || 14 }} />,
      //   pathname: '/admin/inbound-countries'
      // },
    ],
  },
  {
    label: 'Tienda Amazon',
    icon: StoreIcon,
    roles: ['admin', 'reseller', 'retailer', 'wholesaler'],
    children: [
      {
        label: 'Autorización',
        icon: KeyIcon,
        pathname: '/admin/stores/amazon/authorization',
      },
      {
        label: 'Pedidos',
        icon: ShoppingCartIcon,
        pathname: '/admin/stores/amazon/orders',
      },
    ],
  },
  {
    label: 'Tiendas',
    icon: StoreIcon,
    roles: ['admin', 'reseller', 'retailer', 'wholesaler', 'reseller_customer'],
    children: [
      {
        label: 'Lista',
        icon: ListIcon,
        pathname: '/admin/stores',
      },
      {
        label: 'Añadir nueva tienda',
        icon: AddBusinessIcon,
        pathname: '/admin/stores/new',
      },
      {
        label: 'Pedidos',
        icon: ShoppingCartIcon,
        pathname: '/admin/store-orders',
      },
    ],
  },
  {
    label: 'Seguridad',
    icon: SecurityIcon,
    roles: ['admin'],
    children: [
      {
        label: 'Registros de inicio de sesión',
        icon: LogingLogsIcon,
        pathname: '/admin/login-logs',
      },
    ],
  },
];

export default pagesES;
